import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { Logo, Logout, Menu, UserIcon } from '../../Constant/ImageConstant';
import { getUserSession } from '../../utils/auth';
import './Header.css';

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const user_data = getUserSession();
  const [userData, setUserData] = useState(user_data);

  const getLocalData = () => {
    const res = getUserSession();
    if (res) {
      setUserData(res?.loginUserData);
    } else {
      navigate('/');
    }
  };

  const handleLogout = () => {
    navigate('/');
    localStorage.clear();
    window.location.reload('');
  };

  useEffect(() => {
    getLocalData();
  }, []);

  useEffect(() => {}, [userData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isUserMenuOpen && !event.target.closest('.user-profile-container')) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isUserMenuOpen]);

  return (
    <header className="app-header">
      {false && (
        <div className="menu-icon" onClick={toggleSidebar}>
          <img src={Logo} alt="Menu" style={{ height: '40px', width: '50px' }} />
        </div>
      )}
      <div className="logo">
        <img src={Logo} alt="Logo" />
      </div>
      <div className="user-profile-container" style={{ position: 'relative' }}>
        <div
          style={{
            width: 'fit-content',
            alignItems: 'center',
            padding: '3px 0px',
            borderRadius: '25px',
            border: '2px solid #253C80',
            marginTop: '10px',
            marginBottom: '10px',
            display: 'flex',
            cursor: 'pointer'
          }}
          onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
        >
          <img
            src={UserIcon}
            alt="Logo"
            style={{ height: '25px', width: '25px', marginLeft: '8px' }}
          />
          <p style={{ color: '#253C80', margin: '5px 20px' }}>{user_data?.user?.toUpperCase()}</p>
        </div>

        {isUserMenuOpen && (
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: '100%',
              marginTop: '5px',
              width: '250px',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px',
              border: '1px solid #e0e0e0',
              zIndex: 1000
            }}
          >
            <div style={{ padding: '16px' }}>
              <h3 style={{ 
                fontSize: '16px', 
                fontWeight: '600', 
                color: '#253C80',
                marginBottom: '12px' 
              }}>
                User Profile
              </h3>
              <div style={{ marginBottom: '16px' }}>
                <p style={{ fontSize: '14px', color: '#4a5568', marginBottom: '8px' }}>
                  Name: {user_data?.username}
                </p>
                <p style={{ fontSize: '14px', color: '#4a5568' }}>
                  Email: {user_data?.email || 'Not available'}
                </p>
              </div>
              <div
                onClick={handleLogout}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  color: '#dc4226',
                  borderRadius: '6px',
                  transition: 'background-color 0.2s',
                  gap: '8px'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fff5f5'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <img
                  src={Logout}
                  alt="Logout"
                  style={{ height: '20px', width: '20px' }}
                />
                <span>Logout</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;